/*eslint no-undef: "error"*/
/*eslint-env node*/
import axios from 'axios';

const baseUrlData = window.wp_baseUrl
  ? window.wp_baseUrl['base']
  : 'https://www.coordinadora.com';

export async function getDropPoints() {
  return axios
    .get(`${baseUrlData}/wp-json/cdp/v1/drop-points`)
    .then((response) => response.data)
    .catch((error) => {
      window.elementorProFrontend.modules.popup.showPopup({
        id: 11074,
      });
      console.log(error);
    });
}
